import api from '../utils/api';
import {
  OUTDOOR_DATA_FAILED,
  OUTDOOR_DATA_SUCCESS,
  REQUEST_OUTDOOR_DATA,
} from './types';

export const loadOutdoor = (params) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_OUTDOOR_DATA });
    const { data } = await api.get(`/outdoor?${params}`);
    dispatch({ type: OUTDOOR_DATA_SUCCESS, payload: data.data});
  } catch (error) {
    console.log(error);
    dispatch({ type: OUTDOOR_DATA_FAILED });
  }
};


